module.exports = __webpack_public_path__ + "build/img/02.b4018d6f.jpg";